import {ExportMarkdownDialog as CommonExportMarkdownDialog, getMarkdownFilename} from '@dv5/components'
import {clearAllParts, DvDocument, getDocumentAllParts, getDocumentDescriptions, useAppDispatch, useAppSelector} from '@dv5/domain'
import {FC, useEffect} from 'react'
import {documentApi} from '../services/documentService'
import {exportDocumentToMarkdown} from '../services/markdownExportService'

interface Props {
    document: DvDocument
    onClose: () => void
}

export const ExportMarkdownDialog: FC<Props> = ({document, onClose}) => {
    const dispatch = useAppDispatch()
    const allPartsMap = useAppSelector(getDocumentAllParts)
    const descriptions = useAppSelector(getDocumentDescriptions)
    const allParts = allPartsMap[document.id]

    useEffect(() => {
        documentApi.getAllParts(document.id)
        return () => {
            dispatch(clearAllParts({documentId: document.id}))
        }
    }, [])

    const markdown = allParts
        ? exportDocumentToMarkdown(document.title, descriptions[document.id], allParts)
        : null

    return (
        <CommonExportMarkdownDialog
            markdown={markdown}
            filename={getMarkdownFilename(document.title)}
            onClose={onClose}
        />
    )
}
